import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Invoice } from '~hooks/useInvoices/models';

import { FlexColumn } from '../../styled';

interface DriverStopColumnProps {
  invoice: Invoice;
  sx?: SxProps<Theme>;
}

const DriverStopColumn = ({ invoice, sx }: DriverStopColumnProps) => {
  const { adjustedLoggingEndedAt, loggingEndedAt } = invoice.jobSummary ?? {};
  const effectiveEndTime = adjustedLoggingEndedAt ?? loggingEndedAt;

  let stopTime = null;
  let stopDate = null;

  if (effectiveEndTime) {
    stopTime = dayjs.tz(effectiveEndTime).format('hh:mm A');
    stopDate = dayjs.tz(effectiveEndTime).format('DD-MMM-YYYY');
  }

  if (!stopTime && !stopDate) {
    return (
      <Box sx={sx}>
        <OverflowAwareText>-</OverflowAwareText>
      </Box>
    );
  }

  return (
    <Box sx={sx}>
      {(stopTime || stopDate) && (
        <FlexColumn>
          {stopTime && <OverflowAwareText fontWeight={700}>{stopTime}</OverflowAwareText>}
          {stopDate && <OverflowAwareText>{stopDate}</OverflowAwareText>}
        </FlexColumn>
      )}
    </Box>
  );
};

export default DriverStopColumn;
